import {
  Checkbox as MuiCheckbox,
  CheckboxProps,
  lighten,
  Theme,
} from "@mui/material";

const checkboxSxProps = {
  color: "rgba(0,0,0,0.5)",
  "&.Mui-disabled": {
    color: "rgba(0,0,0,0.1)",
    "&.Mui-checked": {
      color: (theme: Theme) => lighten(theme.palette.primary.main, 0.62), // .38
    },
  },
  "&.Mui-checked": {
    color: "primary.main",
    "&:hover": {
      backgroundColor: (theme: Theme) =>
        lighten(theme.palette.primary.main, 0.96), //.04
    },
    "&:focus": {
      border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
    },
  },
};

const Checkbox = ({ name, ...rest }: CheckboxProps): JSX.Element => {
  return (
    <MuiCheckbox
      sx={checkboxSxProps}
      data-testid={name}
      color="default"
      name={name}
      {...rest}
    />
  );
};

export default Checkbox;
